export const defaultSEO = {
    siteName: "Webkredit",
    url: "https://webkredit.ch",
    image: "https://webkredit.ch/assets/logo-full.svg",
};